import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCompanyChildCategory from '../useCompanyChildCategory';

const SingleCompanyChildCategory = () => {
  const { t } = useTranslation();
  const { singleData, loading, companyCategories } =
    useCompanyChildCategory(false);
  const [searchParams] = useSearchParams();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const dataKeys = [
    { key: 'title', text: t('Titolo') },
    { key: 'nego_tov_id', text: t('NEGO ID (TOV)') },
    { key: 'nego_sov_id', text: t('NEGO ID (SOV)') },
    { key: 'nego_rov_id', text: t('NEGO ID (ROV)') },
    { key: 'company_category_id', text: t('Categorie insegne') },
  ];

  const title = isSuccessUpdatePage
    ? t('SOTTOCATEGORIE WAS SUCCESSFULLY UPDATED.')
    : t('SOTTOCATEGORIE');

  const getFieldValue = (key) => {
    const value = singleData?.[key];
    if (key === 'company_category_id') {
      return (
        singleData?.company_category?.title ||
        companyCategories?.find((i) => i.id === value)?.title ||
        value
      );
    }
    return value;
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <List
            header={<div>{t('SOTTOCATEGORIE')}</div>}
            dataSource={dataKeys}
            renderItem={(item) => (
              <List.Item>
                <b className={styles.itemName}>{item.text}</b>
                {getFieldValue(item.key)}
              </List.Item>
            )}
          />
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleData?.can_update !== false && (
            <Col>
              <Button>
                <Link
                  to={`/admin/company_child_categories/${singleData?.id}/edit`}
                >
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/company_child_categories'}>
                {t('TORNA INDIETRO')}
              </Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleCompanyChildCategory;
